const ACRONYMS: Record<string, string> = {
  ai: "AI",
  btc: "BTC",
  cbdcs: "CBDCs",
  dai: "DAI",
  defi: "DeFi",
  dapp: "dApp",
  dapps: "dApps",
  dao: "DAO",
  nft: "NFT",
  usdc: "USDC",
  usdt: "USDT",
  web3: "Web3",
};

function titleCaseWord(word: string): string {
  const trimmed = word.trim();
  const lower = trimmed.toLowerCase();
  if (ACRONYMS[lower]) return ACRONYMS[lower];
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
}

/** Format a raw tag string into a clean editorial label. */
export function formatTag(tag: string): string {
  return tag
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map(titleCaseWord)
    .join(" ");
}

/** Slugify a tag for use in URLs. */
export function slugifyTag(tag: string): string {
  return tag
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-");
}

/** Convert a tag slug back into a display label. */
export function formatTagFromSlug(slug: string): string {
  return formatTag(slug.replace(/-/g, " "));
}
